import { documentsFetch, notesFetch, kbArticlesFetch } from '../../functions/documents/index.js'

export const notes = {
  extends: 'AppPage',
  metadata: { title: 'Notes / Documents / Symbols Workspace' },

  fetch: [
    documentsFetch,
    notesFetch,
    kbArticlesFetch
  ],

  DocsSidebar: {},
  NotesMain: {}
}
